import type { FC, ReactNode } from 'react';
import { TbBriefcase, TbBuilding, TbChartLine, TbFileText, TbLayoutGrid, TbUsers } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { DropdownButtonSelect, LearnMoreFooter } from '@/shared';
import type { AlertCategory, AlertCategoryDefinition } from '@/types';

export const alertCategoryIcons: Record<AlertCategory, ReactNode> = {
    companies: <TbBuilding />,
    documents: <TbFileText />,
    investments: <TbBriefcase />,
    markets: <TbChartLine />,
    people: <TbUsers />,
    workspace: <TbLayoutGrid />,
};

interface AlertCategoryDropdownProps {
    categories: AlertCategoryDefinition[];
    onChange: (category: AlertCategory) => void;
    value: AlertCategory;
}

const AlertCategoryDropdown: FC<AlertCategoryDropdownProps> = ({ categories, onChange, value }) => {
    const { token } = useAntDesignTheme();

    return (
        <DropdownButtonSelect<AlertCategory>
            header={<small style={{ color: token.colorTextTertiary }}>Listen for activity in…</small>}
            footer={<LearnMoreFooter topic='alert categories' variant='dropdown' />}
            menuWidth='22rem'
            value={value}
            options={categories.map((category) => ({
                description: category.description,
                icon: alertCategoryIcons[category.key],
                label: category.label,
                searchText: `${category.label} ${category.description}`,
                value: category.key,
            }))}
            onChange={(category) => {
                if (category) {
                    onChange(category);
                }
            }}
        />
    );
};

export default AlertCategoryDropdown;
